import { render, staticRenderFns } from "./EmailServerSelect.vue?vue&type=template&id=20e77e4a"
import script from "./EmailServerSelect.vue?vue&type=script&lang=js"
export * from "./EmailServerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports